import { tokens } from '@sail/ui';
import { customSpaceTokens } from './space';
export const columnPaddingTokens = {
    none: tokens.space[0],
    small: tokens.space[100],
    normal: tokens.space[200],
    medium: tokens.space[200],
    large: tokens.space[300],
    xlarge: tokens.space[400],
    tablet: {
        medium: tokens.space[400],
        large: tokens.space[800],
        xlarge: tokens.space[800]
    },
    desktop: {
        xlarge: customSpaceTokens[1400]
    }
};
export const rowGapTokens = {
    none: tokens.space[0],
    small: tokens.space[100],
    normal: tokens.space[100],
    medium: tokens.space[300],
    large: tokens.space[400],
    xlarge: tokens.space[800],
    xxlarge: customSpaceTokens[1100]
};
export const customLayoutTokens = {
    columnPadding: Object.fromEntries(Object.entries(columnPaddingTokens).filter(([key])=>key !== 'tablet' && key !== 'desktop')),
    rowGap: rowGapTokens,
    maxWidth: '1080px'
};

//# sourceMappingURL=layout.js.map